import { useEffect, useRef } from 'react';

const photos = [
  '/images/home2.jpeg',
  '/images/pilates1.jpeg',
  '/images/home3.jpeg',
  '/images/pilates2.jpeg',
  '/images/home4.jpeg',
  '/images/pilates3.jpeg',
];

const Gallery = () => {
  const trackRef = useRef(null);
  const pausedRef = useRef(false);

  useEffect(() => {
    const track = trackRef.current;
    if (!track) return;

    const advance = () => {
      if (pausedRef.current) return;
      const slide = track.querySelector('[data-slide]');
      if (!slide) return;
      const width = slide.offsetWidth;
      if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 4) {
        track.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        track.scrollBy({ left: width, behavior: 'smooth' });
      }
    };

    const interval = setInterval(advance, 3000);
    const pause = () => (pausedRef.current = true);
    const resume = () => (pausedRef.current = false);

    track.addEventListener('mouseenter', pause);
    track.addEventListener('touchstart', pause);
    track.addEventListener('mouseleave', resume);
    track.addEventListener('touchend', resume);

    return () => {
      clearInterval(interval);
      track.removeEventListener('mouseenter', pause);
      track.removeEventListener('touchstart', pause);
      track.removeEventListener('mouseleave', resume);
      track.removeEventListener('touchend', resume);
    };
  }, []);

  const scrollByDirection = (dir) => {
    const track = trackRef.current;
    if (!track) return;
    const slide = track.querySelector('[data-slide]');
    if (!slide) return;
    const width = slide.offsetWidth;
    track.scrollBy({ left: dir * width, behavior: 'smooth' });
  };

  return (
    <section className="bg-ink text-cream py-20 px-4 md:px-12" id="galeria">
      <div className="max-w-7xl mx-auto">
        <p className="text-xs tracking-[0.35em] uppercase text-terracotta-light mb-8">Galería</p>

        <div
          ref={trackRef}
          className="flex gap-3 overflow-x-auto pb-2"
          style={{ scrollSnapType: 'x mandatory', scrollbarWidth: 'none' }}
        >
          {photos.map((src, idx) => (
            <div
              key={idx}
              data-slide
              className="flex-none w-[80%] sm:w-[45%] md:w-[31%]"
              style={{ scrollSnapAlign: 'start' }}
            >
              <img
                src={src}
                alt={`Origin Beyond Pilates ${idx + 1}`}
                className="w-full aspect-[4/5] object-cover rounded-md border border-terracotta/30"
              />
            </div>
          ))}
        </div>

        <div className="flex justify-center gap-4 mt-6">
          <button
            type="button"
            onClick={() => scrollByDirection(-1)}
            aria-label="Anterior"
            className="w-12 h-12 rounded-full border border-terracotta-light text-terracotta-light hover:bg-terracotta-light hover:text-ink transition flex items-center justify-center text-xl"
          >
            ‹
          </button>
          <button
            type="button"
            onClick={() => scrollByDirection(1)}
            aria-label="Siguiente"
            className="w-12 h-12 rounded-full border border-terracotta-light text-terracotta-light hover:bg-terracotta-light hover:text-ink transition flex items-center justify-center text-xl"
          >
            ›
          </button>
        </div>
      </div>
    </section>
  );
};

export default Gallery;
